<template><div class="bookPreview">

    <div class="dobook_wait" v-if="props.dobook.wait">
        <vClock class="icon"/>
        <h2>Выполняется бронирование</h2>
        <div class="l">Бронирование может длиться несколько минут</div>
        <div class="l">Пожалуйста не закрывайте страничку и дождитесь результатов</div>
        <div class="l">В <span class="l__time">{{ts_plus}}</span> или позже проверьте появилась ли ваша заявка в личном кабинете и присвоен ли ей номер оператора</div>
        <div class="tm">{{props.dobook.leave_min}}</div>
    </div>


    <template v-if="!dobook.wait">

        <TouristPreviewNew />

        <div v-if="props.maybook.wait"><Loader class="CruisePage__min" /></div>

        <div v-if="!props.maybook.wait && !props.maybook.may" style="margin-bottom: 100px;">
            <div class="error-list" style="margin-bottom: 20px; ">
                Обнаружено следующее:
                <div class="error-list--li" v-for="({text}) in props.maybook.errors">{{text}}</div>
            </div>
        </div>

    </template>


</div></template>

<style lang="scss" src="./Preview.scss"></style>

<script setup>
import {computed} from 'vue'    
import dayjs from 'dayjs'
import Loader from '@/comp/Loader/Loader.vue'
import {CRUISE_BOOK_MAX} from '@/actions.js'
import TouristPreviewNew from '@/comp/TouristPreview/TouristPreviewNew.vue'
import vClock from '@/assets/vicons/clock-countdown.vue'

const props = defineProps({
    maybook : Object,
    dobook : Object,
})

const ts_plus = computed( () => {
    let {ts} = props.dobook
    let ret = '??:??'
    if (ts) {
        ret = dayjs( ts ).add(CRUISE_BOOK_MAX,'s').format('HH:mm')
    }
    return ret
})

</script>
